import { supabaseClient, useUser } from '@auth-v2';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { fetchFloorSettings, upsertFloorSettings } from '@data';
import type { FloorSettings } from '@data';

export const floorSettingsKey = (userId: string) => [userId, 'floorSettings'];

export const useFloorSettings = () => {
    const { data: user } = useUser();

    return useQuery({
        queryKey: floorSettingsKey(user?.id ?? ''),
        queryFn: () => fetchFloorSettings(supabaseClient),
        refetchOnMount: false,
        enabled: !!user?.id,
    });
};

export const useUpsertFloorSettings = () => {
    const { data: user } = useUser();
    const queryClient = useQueryClient();
    const userId = user?.id ?? '';
    return useMutation({
        mutationFn: (floorSettings: FloorSettings) => upsertFloorSettings(supabaseClient, userId, floorSettings),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: floorSettingsKey(userId) });
        },
    });
};
